
import "./App.css";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import HeroSlider from "./HeroSlider";
import Practice_Areas from "./Practice_Areas";
import ContactSection2 from "./ContactSection2";
import About from "./About";
import Common_Law_Partners_and_Surrogate_Family_Units from "./Common_Law_Partners_and_Surrogate_Family_Units";
import Enduring_Power_of_Attorney from "./Enduring_Power_of_Attorney";
import Property_Distribution_and_Resource_Balancing from "./Category/Property_Distribution_and_Resource_Balancing";
import Parental_Responsibility_and_Visitation_Time from "./Category/Parental_Responsibility_and_Visitation_Time";
import Child_Support_and_Wife_Support from "./Category/Child_Support_and_Wife_Support";
import Matters_of_the_Rabbinical_Court from "./Category/Matters_of_the_Rabbinical_Court";
import Divorce_and_Mediation_Agreements from "./Category/Divorce_and_Mediation_Agreements";
import Urgent_Orders_and_Protection from "./Category/Urgent_Orders_and_Protection";
import The_race_for_authority from "./Category2/The_race_for_authority";
import International_Divorce from "./Category2/International_Divorce";
import Prenuptial_Relations_and_Wills_in_Divorce from "./Category2/Prenuptial_Relations_and_Wills_in_Divorce";
import Civil_Marriage_and_Invalid_Marriage from "./Category2/Civil_Marriage_and_Invalid_Marriage";
import Torts_Claims_Between_Spouses from "./Category2/Torts_Claims_Between_Spouses";
import Guardianship_and_Parental_Alienation from "./Category2/Guardianship_and_Parental_Alienation";
import Initial_Legal_Guidance from "./Initial_Legal_Guidance";
import CookieConsent from "./CookieConsent";
import WhatsAppBot from "./WhatsAppBot";
import AccessibilityWidget from "./AccessibilityWidget";
import NotFound from "./NotFound";
import Privacy_Policy from "./Privacy_Policy/Privacy_Policy";

const SITE_URL = "https://razfamilylaw.co.il";
const SITE_IMAGE = `${SITE_URL}/logo.png`;

const seoPages = {
  home: {
    title: "רז יוסף – משרד עורכי דין בנתניה | דיני משפחה וגירושין",
    description: "משרד עורכי הדין רז יוסף בנתניה מעניק ייעוץ וייצוג משפטי בדיני משפחה, הליכי גירושין, מזונות, אחריות הורית, חלוקת רכוש והסכמים. למעלה מ-24 שנות ניסיון וליווי אישי.",
    keywords: "רז יוסף עורך דין, משרד עורכי דין נתניה, עורך דין משפחה, עורך דין גירושין, דיני משפחה, תביעות מזונות, אחריות הורית, חלוקת רכוש, הסכם גירושין",
    path: "/"
  },

  services: {
    title: "תחומי עיסוק משפטיים | רז יוסף – משרד עורכי דין בנתניה",
    description: "משרד עורכי הדין רז יוסף בנתניה מעניק ייעוץ וייצוג משפטי בתחומי דיני המשפחה, גירושין, חלוקת רכוש, אחריות הורית, מזונות, הסכמי גירושין, גישור וייפוי כוח מתמשך.",
    keywords: "תחומי עיסוק עורך דין, עורך דין גירושין נתניה, חלוקת רכוש, אחריות הורית, מזונות, הסכם גירושין, גישור משפחתי, ייפוי כוח מתמשך",
    path: "/ServicesPage"
  },

  contact: {
    title: "יצירת קשר | עורך דין רז יוסף בנתניה",
    description: "צרו קשר עם משרד עורכי הדין רז יוסף בנתניה לקבלת מידע, ייעוץ וליווי משפטי. טלפון: 050-757-5775.",
    keywords: "יצירת קשר עורך דין רז יוסף, עורך דין נתניה, ייעוץ משפטי",
    path: "/ContactSection2"
  },

  about: {
    title: "אודות משרד עורכי הדין רז יוסף | למעלה מ-24 שנות ניסיון",
    description: "הכירו את משרד עורכי הדין רז יוסף בנתניה, המעניק ליווי וייצוג משפטי מקצועי בתחומי דיני המשפחה עם ניסיון של למעלה מ-24 שנים.",
    keywords: "רז יוסף עורך דין, אודות משרד עורכי דין, עורך דין נתניה",
    path: "/About"
  },

  commonLaw: {
    title: "ידועים בציבור ותאים משפחתיים חלופיים | עורך דין רז יוסף",
    description: "ייעוץ וליווי משפטי בנושאי ידועים בציבור, זכויות בני זוג, הסדרת יחסים ורכוש ותאים משפחתיים חלופיים במשרד עורכי הדין רז יוסף בנתניה.",
    keywords: "ידועים בציבור, זכויות ידועים בציבור, הסכם חיים משותפים, תאים משפחתיים חלופיים, עורך דין משפחה נתניה",
    path: "/Common_Law_Partners_and_Surrogate_Family_Units"
  },

  enduringPower: {
    title: "ייפוי כוח מתמשך | עורך דין רז יוסף בנתניה",
    description: "מידע וליווי משפטי בעריכת ייפוי כוח מתמשך, בחירת מיופה כוח והסדרת רצונותיו של אדם לעתיד. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "ייפוי כוח מתמשך, עריכת ייפוי כוח מתמשך, עורך דין ייפוי כוח מתמשך, מיופה כוח, עורך דין רז יוסף, נתניה",
    path: "/Enduring_Power_of_Attorney"
  },

  property: {
    title: "חלוקת רכוש ואיזון משאבים בגירושין | עורך דין רז יוסף בנתניה",
    description: "מידע וייעוץ משפטי בנושא חלוקת רכוש ואיזון משאבים בהליכי גירושין, לרבות דירות, חסכונות, זכויות פנסיוניות, חובות והסכמי ממון. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "חלוקת רכוש בגירושין, איזון משאבים, עורך דין חלוקת רכוש, עורך דין איזון משאבים, חלוקת דירה בגירושין, זכויות פנסיה בגירושין, הסכם ממון, חלוקת נכסים בין בני זוג, עורך דין גירושין נתניה",
    path: "/Property_Distribution_and_Resource_Balancing"
  },

  parental: {
    title: "אחריות הורית וזמני שהות | עורך דין רז יוסף בנתניה",
    description: "ייעוץ וייצוג משפטי בנושא אחריות הורית, קביעת זמני שהות והסדרי שהות לילדים בהליכי פרידה וגירושין. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "אחריות הורית, זמני שהות, הסדרי שהות, משמורת ילדים, טובת הילד, עורך דין אחריות הורית, עורך דין משפחה נתניה",
    path: "/Parental_Responsibility_and_Visitation_Time"
  },

  childSupport: {
    title: "מזונות ילדים ומזונות אישה | עורך דין רז יוסף",
    description: "ייעוץ וייצוג משפטי בתביעות מזונות ילדים ומזונות אישה, קביעת גובה המזונות, שינוי מזונות והתמודדות עם מחלוקות בנושא. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "מזונות ילדים, מזונות אישה, תביעת מזונות, חישוב מזונות, שינוי גובה מזונות, עורך דין מזונות, עורך דין משפחה נתניה",
    path: "/Child_Support_and_Wife_Support"
  },

  rabbinicalCourt: {
    title: "ענייני בית הדין הרבני | עורך דין רז יוסף",
    description: "ייעוץ וייצוג משפטי בענייני בית הדין הרבני, הליכי גירושין, סידור גט, כתובה, שלום בית וסמכויות בית הדין. משרד עורכי הדין רז יוסף.",
    keywords: "בית הדין הרבני, עורך דין בית דין רבני, תביעת גירושין, סידור גט, כתובה, שלום בית, עורך דין גירושין נתניה",
    path: "/Matters_of_the_Rabbinical_Court"
  },

  divorceMediation: {
    title: "הסכמי גירושין וגישור | עורך דין רז יוסף",
    description: "ליווי משפטי בהליכי גישור וגיבוש הסכמי גירושין, לרבות חלוקת רכוש, מזונות, אחריות הורית וזמני שהות. עורך דין רז יוסף בנתניה.",
    keywords: "הסכם גירושין, גישור גירושין, עורך דין הסכם גירושין, חלוקת רכוש, מזונות, אחריות הורית, עורך דין גירושין נתניה",
    path: "/Divorce_and_Mediation_Agreements"
  },

  urgentOrders: {
    title: "צווי הגנה וצווים דחופים בענייני משפחה | עורך דין רז יוסף",
    description: "ייעוץ וייצוג משפטי בבקשות לצווי הגנה, צווי הרחקה, צווים דחופים וסעדים זמניים בענייני משפחה. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "צו הגנה, צו הרחקה, צווים דחופים, סעדים זמניים, אלימות במשפחה, עורך דין צו הגנה, עורך דין משפחה נתניה",
    path: "/Urgent_Orders_and_Protection"
  },

  authority: {
    title: "מרוץ הסמכויות בדיני משפחה | עורך דין רז יוסף",
    description: "מידע וייעוץ משפטי בנושא מרוץ הסמכויות בין בית המשפט לענייני משפחה לבית הדין הרבני, בחירת ערכאה והשלכות משפטיות.",
    keywords: "מרוץ הסמכויות, בית הדין הרבני, בית המשפט לענייני משפחה, סמכות שיפוט, עורך דין משפחה נתניה",
    path: "/The_race_for_authority"
  },

  internationalDivorce: {
    title: "גירושין בינלאומיים | עורך דין רז יוסף בנתניה",
    description: "ייעוץ משפטי בנושא גירושין בינלאומיים, בני זוג ממדינות שונות, סמכות שיפוט, הכרה בפסקי דין והיבטים משפטיים חוצי גבולות.",
    keywords: "גירושין בינלאומיים, עורך דין גירושין בינלאומי, סמכות שיפוט, גירושין בחו״ל, עורך דין משפחה נתניה",
    path: "/International_Divorce"
  },

  prenuptial: {
    title: "הסכמי ממון וצוואות בהליכי גירושין | עורך דין רז יוסף",
    description: "ייעוץ משפטי בנושא הסכמי ממון, צוואות והשלכותיהם בהליכי פרידה וגירושין. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "הסכם ממון, צוואה, הסכמי ממון בגירושין, עורך דין הסכם ממון, דיני משפחה נתניה",
    path: "/Prenuptial_Relations_and_Wills_in_Divorce"
  },

  civilMarriage: {
    title: "נישואים אזרחיים ונישואים פסולים | עורך דין רז יוסף",
    description: "מידע וייעוץ משפטי בנושא נישואים אזרחיים, תוקף הנישואים, הכרה במעמד אישי והליכי פרידה וגירושין.",
    keywords: "נישואים אזרחיים, נישואים פסולים, תוקף נישואים, מעמד אישי, עורך דין משפחה נתניה",
    path: "/Civil_Marriage_and_Invalid_Marriage"
  },

  spousalTorts: {
    title: "תביעות נזיקין בין בני זוג | עורך דין רז יוסף",
    description: "ייעוץ וייצוג משפטי בתביעות נזיקין בין בני זוג, אחריות משפטית, פגיעה בזכויות וסוגיות נזיקיות במסגרת סכסוכים משפחתיים.",
    keywords: "תביעות נזיקין בין בני זוג, נזיקין במשפחה, תביעות בין בני זוג, עורך דין משפחה נתניה",
    path: "/Torts_Claims_Between_Spouses"
  },

  guardianship: {
    title: "אפוטרופסות וניכור הורי | עורך דין רז יוסף",
    description: "ייעוץ משפטי בענייני אפוטרופסות, אחריות הורית, ניכור הורי וטובת הילד במסגרת סכסוכים משפחתיים. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "אפוטרופסות, ניכור הורי, טובת הילד, אחריות הורית, עורך דין משפחה נתניה",
    path: "/Guardianship_and_Parental_Alienation"
  },

  initialGuidance: {
    title: "ייעוץ והכוונה משפטית ראשונית | עורך דין רז יוסף",
    description: "מידע והכוונה משפטית ראשונית בנושאי דיני משפחה, גירושין, מזונות, חלוקת רכוש והסדרים הנוגעים לילדים. משרד עורכי הדין רז יוסף בנתניה.",
    keywords: "ייעוץ משפטי ראשוני, הכוונה משפטית, עורך דין משפחה, עורך דין גירושין, ייעוץ דיני משפחה נתניה",
    path: "/Initial_Legal_Guidance"
  },

  privacy: {
    title: "מדיניות פרטיות | משרד עורכי דין רז יוסף",
    description: "מדיניות הפרטיות של משרד עורכי הדין רז יוסף. מידע על איסוף מידע אישי, השימוש בו, Cookies, אבטחת מידע וזכויות המשתמשים באתר.",
    keywords: "מדיניות פרטיות, פרטיות משתמשים, משרד עורכי דין רז יוסף, הגנת הפרטיות",
    path: "/Privacy_Policy"
  }
};

function PageSEO({ page }) {
  if (!page) return null;

  const canonicalUrl = `${SITE_URL}${page.path}`;

  return (
    <Helmet>
      <title>{page.title}</title>

      <meta name="description" content={page.description} />
      <meta name="keywords" content={page.keywords} />

      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:image" content={SITE_IMAGE} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="רז יוסף – משרד עורכי דין" />
      <meta property="og:locale" content="he_IL" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={SITE_IMAGE} />
    </Helmet>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />

      <AccessibilityWidget />

      <div id="site-content">
        <Header />
        <CookieConsent />
        <WhatsAppBot />

<Switch>
  <Route exact path="/" render={() => <><PageSEO page={seoPages.home} /><HeroSlider /></>} />
  <Route exact path="/Practice_Areas" render={() => <><PageSEO page={seoPages.services} /><Practice_Areas /></>} />
  <Route exact path="/ContactSection2" render={() => <><PageSEO page={seoPages.contact} /><ContactSection2 /></>} />
  <Route exact path="/About" render={() => <><PageSEO page={seoPages.about} /><About /></>} />
  <Route exact path="/Common_Law_Partners_and_Surrogate_Family_Units" render={() => <><PageSEO page={seoPages.commonLaw} /><Common_Law_Partners_and_Surrogate_Family_Units /></>} />
  <Route exact path="/Enduring_Power_of_Attorney" render={() => <><PageSEO page={seoPages.enduringPower} /><Enduring_Power_of_Attorney /></>} />
  <Route exact path="/Property_Distribution_and_Resource_Balancing" render={() => <><PageSEO page={seoPages.property} /><Property_Distribution_and_Resource_Balancing /></>} />
  <Route exact path="/Parental_Responsibility_and_Visitation_Time" render={() => <><PageSEO page={seoPages.parental} /><Parental_Responsibility_and_Visitation_Time /></>} />
  <Route exact path="/Child_Support_and_Wife_Support" render={() => <><PageSEO page={seoPages.childSupport} /><Child_Support_and_Wife_Support /></>} />
  <Route exact path="/Matters_of_the_Rabbinical_Court" render={() => <><PageSEO page={seoPages.rabbinicalCourt} /><Matters_of_the_Rabbinical_Court /></>} />
  <Route exact path="/Divorce_and_Mediation_Agreements" render={() => <><PageSEO page={seoPages.divorceMediation} /><Divorce_and_Mediation_Agreements /></>} />
  <Route exact path="/Urgent_Orders_and_Protection" render={() => <><PageSEO page={seoPages.urgentOrders} /><Urgent_Orders_and_Protection /></>} />
  <Route exact path="/The_race_for_authority" render={() => <><PageSEO page={seoPages.authority} /><The_race_for_authority /></>} />
  <Route exact path="/International_Divorce" render={() => <><PageSEO page={seoPages.internationalDivorce} /><International_Divorce /></>} />
  <Route exact path="/Prenuptial_Relations_and_Wills_in_Divorce" render={() => <><PageSEO page={seoPages.prenuptial} /><Prenuptial_Relations_and_Wills_in_Divorce /></>} />
  <Route exact path="/Civil_Marriage_and_Invalid_Marriage" render={() => <><PageSEO page={seoPages.civilMarriage} /><Civil_Marriage_and_Invalid_Marriage /></>} />
  <Route exact path="/Torts_Claims_Between_Spouses" render={() => <><PageSEO page={seoPages.spousalTorts} /><Torts_Claims_Between_Spouses /></>} />
  <Route exact path="/Guardianship_and_Parental_Alienation" render={() => <><PageSEO page={seoPages.guardianship} /><Guardianship_and_Parental_Alienation /></>} />
  <Route exact path="/Initial_Legal_Guidance" render={() => <><PageSEO page={seoPages.initialGuidance} /><Initial_Legal_Guidance /></>} />
  <Route exact path="/Privacy_Policy" render={() => <><PageSEO page={seoPages.privacy} /><Privacy_Policy /></>} />
  <Route render={() => <><Helmet><title>העמוד לא נמצא | רז יוסף משרד עורכי דין</title><meta name="robots" content="noindex, follow" /></Helmet><NotFound /></>} />
</Switch>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
